module.exports = __webpack_public_path__ + "static/media/49.4ce22013.jpg";